export default function () {
  const biJsHost =
    document.location.protocol == 'https:' ? 'https://' : 'http://'
  ;(function (d, s, id, tid, vid) {
    const ljs = d.getElementsByTagName(s)[0]
    if (d.getElementById(id)) return
    const js = d.createElement(s)
    js.id = id
    js.src =
      biJsHost + 'cdn.listrakbi.com/scripts/script.js?m=' + tid + '&v=' + vid
    ljs.parentNode.insertBefore(js, ljs)
  })(document, 'script', 'ltkSDK', 'zDZQqL9SGocG', '1')
}
